import React from "react";
import { useQuery } from "../../_utils/url_query_hook";
import { buildEmptyActivityFormTemplate, transformEntityActivityFormTemplate } from "../../_events/activity_form_template/model";
import { findActivityFormTemplateByIdEvent } from "../../_events/activity_form_template/find.event";
import { createActivityFormTemplateEvent, editActivityFormTemplateEvent } from "../../_events/activity_form_template/create.event";
import { alertError, alertSuccess } from "../../_utils/alerts";

export const useActivityFormTemplateCreateEdit = (form = '') => {

    const query = useQuery();
    const uuid = query.get("uuid");

    const [ entity, setEntity ] = React.useState(buildEmptyActivityFormTemplate(form));

    const create = () => {
        createActivityFormTemplateEvent(entity)
        .then(json => {
            alertSuccess("Guardado");
            setEntity(buildEmptyActivityFormTemplate(form));
        })
        .catch(err => {
            alertError(err.message);
        });
    }

    const createAndLoad = (activity, loadFunc = () => {}) => {
        let newEnt = {...entity};
        newEnt.activity = activity;
        createActivityFormTemplateEvent(newEnt)
        .then(json => {
            alertSuccess("Guardado");
            setEntity(buildEmptyActivityFormTemplate(form));
            loadFunc();
        })
        .catch(err => {
            alertError(err.message);
        });
    }

    const edit = () => {
        editActivityFormTemplateEvent(uuid, entity)
        .then(json => {
            alertSuccess("Actualizado");
        })
        .catch(err => {
            alertError(err.message);
        });
    }

    React.useEffect(() => {
        if(uuid){
            findActivityFormTemplateByIdEvent(uuid)
            .then(json => {
                setEntity(transformEntityActivityFormTemplate(json.data));
            })
            .catch(err => {
                alertError(err.message);
            })
        }
    }, [uuid]);

    return { entity, setEntity, uuid, create, edit, createAndLoad };
}